const investorData = {
  policies: {
    title: "Policies",
    files: [
      {
        name: "POSH Policy",
        pdf: "/PDF/POSH/POSH Policy.pdf",
      },
      {
        name: "Complain Form for POSH",
        pdf: "/PDF/POSH/Complain Form for POSH.pdf",
      },
      {
        name: "Internal Procedures and Conduct for Prevention of Insider Trading",
        pdf: "/PDF/Internal-Procedures-and-Conduct-for-Prevention-of-Insider-Trading.pdf",
      },
      {
        name: "Policy for Determination of Material Events and Disclosure",
        pdf: "/PDF/Policy-for-Determination-of-Material-Events-and-Disclosure.pdf",
      },
      {
        name: "Policy for Archival of Documents",
        pdf: "/PDF/Policy-for-Archival-of-Documents.pdf",
      },
      {
        name: "Nomination and Remuneration Policy",
        pdf: "/PDF/Nomination-and-Remuneration-Policy.pdf",
      },
      {
        name: "Policy on Identification of Material Creditors, Group Companies and Material Litigation",
        pdf: "/PDF/Policy-on-Identification-of-Material-Creditors-Group-Companies-and-Material-Litigation.pdf",
      },
      {
        name: "Policy on Evaluation of Board and Independent Directors",
        pdf: "/PDF/Policy-on-Evaluation-of-Board-and-Independent-Directors.pdf",
      },
      {
        name: "Policy for Determination of Material Subsidiaries",
        pdf: "/PDF/Policy-for-Determination-of-Material-Subsidiaries.pdf",
      },
      {
        name: "Policy on Prevention of Sexual Harassment at Workplace",
        pdf: "/PDF/Policy-on-Prevention-of-Sexual-Harrasment-at-Workplace.pdf",
      },
      {
        name: "Policy on Related Party Transactions",
        pdf: "/PDF/Policy-on-Related-Party-Transactions.pdf",
      },
      {
        name: "Policy on Succession Planning for Board and Senior Management",
        pdf: "/PDF/Policy-on-Succession-Planning-for-Board-and-Senior-Management.pdf",
      },
      {
        name: "Policy on Terms of Appointment of Independent Directors",
        pdf: "/PDF/Policy-on-Terms-of-Appointment-of-Independent-Directors.pdf",
      },
      {
        name: "Policy on Diversity on Board",
        pdf: "/PDF/Policy-on-Diversity-on-Board.pdf",
      },
      {
        name: "Vigil Mechanism Whistle Blower Policy for Directors and Employees",
        pdf: "/PDF/Vigil-Mechanism_Whistle-Blower-Policy-for-Directors-and-Employees.pdf",
      },
      {
        name: "Health, Safety and Environment Policy",
        pdf: "/PDF/Health-Safety-and-Environment-Policy.pdf",
      },
      {
        name: "Familiarization Program for Independent Directors",
        pdf: "/PDF/Familiarization-Program-for-Independent-Directors.pdf",
      },
    //   {
    //     name: "Dividend Distribution Policy",
    //     pdf: "",
    //   },
      {
        name: "Code of Fair Disclosure",
        pdf: "/PDF/Code-of-Fair-Disclosure.pdf",
      },
      {
        name: "CSR Policy",
        pdf: "/PDF/CSR-Policy.pdf",
      },
      {
        name: "Risk Management Policy",
        pdf: "/PDF/Risk-Management-Policy.pdf",
      },
      {
        name: "Code of Conduct for Directors & Senior Management",
        pdf: "/PDF/Code-of-Coduct-for-Directors-Senior-Management.pdf",
      },

    ],
  },

  "annual-report": {
    title: "Annual Report",
    files: [
    // { 
    //     name: "Annual Report FY 2025 - 2026",
    //     pdf: "/PDF/report/Annual Report 2025-26.pdf",
    //  },
     { 
        name: "Annual Report FY 2024 - 2025",
        pdf: "/PDF/report/Annual-Report-FY-2024-25-2.pdf",
     },
    { 
        name: "Annual Report FY 2023 - 2024", 
        pdf: "/PDF/report/Annual-Report-FY-2023-–-2024.pdf", 
    },
    { 
        name: "Annual Report FY 2022 - 2023",
        pdf: "/PDF/report/Annual-Report-FY-2022-–-2023.pdf",
    },
    { 
        name: "Annual Report FY 2021 - 2022", 
        pdf: "/PDF/report/Annual-Report-FY-2021-–-2022.pdf", 
    },
    { 
        name: "Annual Report FY 2020 - 2021",
        pdf: "/PDF/report/Annual-Report-FY-2020-–-2021.pdf",
    },
    { 
        name: "Annual Report FY 2019 - 2020", 
        pdf: "/PDF/report/Annual-Report-FY-2019-–-2020.pdf",
    },
    ],
  },

  "annual-return": {
    title: "Annual Return",
    files: [
    {
        name: "Annual Return 2024-25",
        pdf: "/PDF/return/Annual-Return_2024-25.pdf" 
    },
    {
        name: "Annual Return 2023-24",
        pdf: "/PDF/return/Annual-Return_2023-24.pdf" 
    },
    {
        name: "Annual Return 2022-23",
        pdf: "/PDF/return/Annual-Return_2022-23-1.pdf" 
    },
    {
        name: "Annual Return 2021-22",
        pdf: "/PDF/return/Annual-Return_2021-22.pdf" 
    },
    {
        name: "Annual Return 2020-21",
        pdf: "/PDF/return/Annual-Return_2020-21.pdf" 
    },
 
    ],
  },
  
  "shareholding-pattern": {
    title: "Share Holding Pattern", 
    images: [
    { src: "/PDF/Shareholders/Shareholders.jpg", alt: "Revenue Chart" }
  ]  
  },

  "group-companies": {
    title: "Group Companies",
    groups: [
      {
        company: "Parnami Incense Private Limited",
        files: [
          {
            name: "Audited Financials 2024-25",
            pdf: "/PDF/group/Audited-Financials-2024-25-Parnami-Incense.pdf",
          },
          {
            name: "Audited Financials 2023-24",
            pdf: "/PDF/group/Audited-Financials_2023-24.pdf",
          },
          {
            name: "Audited Financials 2022-23",
            pdf: "/PDF/group/Audited-Financials_2022-23.pdf",
          },
          {
            name: "Audited Financials 2021-22",
            pdf: "/PDF/group/Audited-Financials_2021-22.pdf",
          },
          {
            name: "MOA-AOA Parnami Incense",
            pdf: "/PDF/group/MOA-AOA_Parnami-Incense.pdf",
          },
        ],
      },

      {
        company: "Galaxy Concab India Private Limited",
        files: [
          {
            name: "Audited Financials 2024-25",
            pdf: "/PDF/group/Audited-Financials-2024-25-Galaxy-Concab.pdf",
          },
          {
            name: "Audited Financials 2023-24",
            pdf: "/PDF/group/Audited-Financials_2023-24-1.pdf",
          },
           {
            name: "Audited Financials 2022-23",
            pdf: "/PDF/group/Audited-Financials_2022-23-1.pdf",
          },
          {
            name: "Audited Financials 2021-22",
            pdf: "/PDF/group/Audited-Financials_2021-22-1.pdf",
          },
          {
            name: "MOA-AOA Galaxy Concab",
            pdf: "/PDF/group/MOA-AOA_Galaxy-Concab.pdf",
          },
        ],
      },
    ],
  },

  "investor-grievance-contact": {
  title: "Investors Grievances",

contacts: [
{
text: "Any query on Annual Report / Institutional Investors / Analysts :",  
name: "Shipra Gandhi ",
role: "(Company Secretary & Compliance Officer)",
address: "Plot No. 14 & 15, First Floor, Gajraj Apartment, Opp. Neelam Hotel, Motilal Atal Road, Jaipur – 302001, Rajasthan.",
phone: "+91 9116135709",
email: "cs@swastikainfra.com",
website:"www.swastikainfra.com"
},
{
text:" For any query relating to the securities of the Company, the investor may contact :",
name: "MUFG Intime India Private Limited",
role: "(Formerly Link Intime India Private Limited)",
address: "B Wing, 2nd Floor, Embassy 247, L.B.S. Marg, Vikhroli (West), Mumbai – 400 083.",
phone: "+91 9769568398",
email: " sanjeeb.das@in.mpms.mufg.com",
website:"www.swastikainfra.com"

},
],

 
},
 ipo: {
  title: "IPO",
  groups: [
    {
      company: "DRHP",
      files: [
        {
          name: "DRHP",
          pdf: "/PDF/IPO/SWASTIKA_DRHP.pdf",
         
         
        },
        {
          name: "DRHP Filing Advertisement",
          pdf: "/PDF/IPO/Advertisement_Swastika.pdf",
         
        },
      ],
    },

    {
      company: "Pre-IPO Advertisement",
      files: [
        {
          name: "Swastika Infra Public Announcement Pre-IPO",
          pdf: "/PDF/IPO/Swastika-Infra_Public-Announcement-Pre-IPO_-1.pdf",
         
        },
      ],
    },

    {
      company: "RHP",
      files: [], 
    },

    {
      company: "Prospectus",
      files: [], 
    },

    {
  company: "AV Presentation",
  files: [],   // ye add karo
  videos: [
    {
      src: "/video file/hindi-AV.mp4",
      name: "Audio Visual (AV) Content Of DRHP-Hindi",
    }, 
    {
      src: "/video file/English-AV.mp4",
      name: "Audio Visual (AV) Content Of DRHP-English"
    }
  ]
}
  ],
},

 "industry-report": {
    title: "Industry Report",
    files: [
    { 
        name: "Final Industry Report - India Power EPC Market (2025) - Mordor Intelligence",
        pdf: "/PDF/industry-report/Final-Industry-Report-India-Power-EPC-Market-2025-Mordor-Intelligence.pdf"
     },
 
    ],
  },

 materialcontracts : {
  title: "Material Contracts & Document",
  groups: [
    {
      company: "Material Contracts ",
      files: [
        {
          name: "CDSL Agreement",
          pdf: "/PDF/C&D/CDSL-Agreement.pdf"
        },
        {
          name: "NSDL Agreement",
          pdf: "/PDF/C&D/NSDL-Agreement.pdf"
        },
          {
          name: "RTA Agreement",
          pdf: "/PDF/C&D/RTA-Agreement.pdf"
        },
      ],
    },

    {
      company: "Material  Document",
      files: [
        {
          name: "MOA-AOA",
          pdf: "/PDF/C&D/MOA-AOA.pdf"
        },
        {
          name: "CTC-30.03.2025-DRHP Approval",
         pdf: "/PDF/C&D/CTC-30.03.2025-DRHP-Approval.pdf"
        },
        {
          name: "CTC-27.03.2025-OFS Approval",
          pdf: "/PDF/C&D/CTC-27.03.2025-OFS-Approval.pdf"
        },
        {
          name: "Certificate on Capitalization Statement",
          pdf: "/PDF/C&D/Certificate-on-Capitalization-Statement.pdf"
        },
        {
          name: "Certificate on Working Capital Requirements",
          pdf: "/PDF/C&D/Certificate-on-Working-Capital-Requirements.pdf"
        },
        {
          name: "OFS Consents",
          pdf: "/PDF/C&D/OFS-Consents.pdf"
        },
        {
          name: "CTC-06.03.2025-Offer Authorization",
          pdf: "/PDF/C&D/CTC-06.03.2025-Offer-Authorization.pdf"
        },
        {
          name: "Certificate on Eligibility for the Issue",
          pdf: "/PDF/C&D/Certificate-on-Eligibility-for-the-Issue.pdf"
        },
        {
          name: "Certificate on Financial Indebtedness",
          pdf: "/PDF/C&D/Certificate-on-Financial-Indebtedness.pdf"
        },
        {
          name: "Certificate on Key Performance Indicators",
          pdf: "/PDF/C&D/Certificate-on-Key-Performance-Indicators.pdf"
        },
        {
          name: "Certificate on Non-payment of Statutory dues",
         pdf: "/PDF/C&D/Certificate-on-Non-payment-of-Statutory-dues.pdf"
        },
        {
          name: "Certificate on Outstanding dues to creditors",
          pdf: "/PDF/C&D/Certificate-on-Outstanding-dues-to-creditors.pdf"
        },
        {
          name: "Certificate on Outstanding Litigation",
          pdf: "/PDF/C&D/Certificate-on-Outstanding-Litigation.pdf"
        },
        {
          name: "Certificate on Related Party Transactions",
          pdf: "/PDF/C&D/Certificate-on-Related-Party-Transactions.pdf"
        },
        {
          name: "Certificate on Statement of Tax Benefits",
          pdf: "/PDF/C&D/Certificate-on-Statement-of-Tax-Benefits.pdf"
        },
        {
          name: "Certificate on Weighted Avg Cost of Acquisition",
          pdf: "/PDF/C&D/Certificate-on-Weighted-Avg-Cost-of-Acquisition.pdf"
        },
        {
          name: "CTC-19.03.2025-Offer Authorization",
          pdf: "/PDF/C&D/CTC-19.03.2025-Offer-Authorization.pdf"
        },
        {
          name: "Independent Examination Report-RFS",
          pdf: "/PDF/C&D/Independent-Examination-Report-RFS.pdf"
        },
        {
          name: "SEBI Final Observation Letter",
         pdf: "/PDF/C&D/SEBI-Final-Observation-Letter.pdf"
        },
        {
          name: "In-Principle Listing Approval-NSE",
          pdf: "/PDF/C&D/In-Principle-Listing-Approval-NSE.pdf"
        },
        {
          name: "In-Principle Listing Approval-BSE",
          pdf: "/PDF/C&D/In-Principle-Listing-Approval-BSE.pdf"
        },

      ],
    },


  
  ],
},
  
 "name-change": {
    title: "New & Old Name of Company",
     images: [
    { src: "/images/New.jpg", alt: "company names " }
  ]  
  },
};

export default investorData;
